import Vue from "vue";
import VueRouter from "vue-router";

// コンポーネント
import MaskLP from "../components/MaskLP.vue";
import TextaLP from "../components/TextaLP.vue";
import JudgeMask from "../components/JudgeMask.vue";
import LightblueHP from "../components/LightblueHP.vue";
import AboutCompany from "../components/AboutCompany.vue";
import InfoDectation from "../components/InfoDectation.vue";
import WashHands from "../components/WashHands.vue";
import MotionAnalysisYoutube from "../components/MotionAnalysisYoutube.vue";
import Seminar1203 from "../components/Seminar1203.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   //  追加
  //   path: "/追加するパス",
  //   name: "FileName,
  //   component: FileName,
  //   beforeEnter() {
  //     window.location =
  //       "目的のpath";
  //   }
  // },
  {
    //  会社紹介
    path: "/about_company",
    name: "AboutCompany",
    component: AboutCompany,
    beforeEnter() {
      window.location =
        "https://drive.google.com/file/d/1BGnJOYOmGX1_5UeYlplVfovX5oM_jyWZ/view";
    }
  },
  {
    // 情報抽出
    path: "/info_dectation",
    name: "InfoDectation",
    component: InfoDectation,
    beforeEnter() {
      window.location = "https://youtu.be/jhg1hAs60L0";
    }
  },
  {
    // lightblue の HP
    path: "/Lightblue_HP",
    name: "LightblueHP",
    component: LightblueHP,
    beforeEnter() {
      window.location = "https://www.lightblue-tech.com/";
    }
  },
  {
    // 動作解析 youtube
    path: "/motion_analysis_youtube",
    name: "MotionAnalysisYoutube",
    component: MotionAnalysisYoutube,
    beforeEnter() {
      window.location = "https://youtu.be/RI9sqJQrJt0";
    }
  },
  {
    // textaLP
    path: "/texta_LP",
    name: "TextaLP",
    component: TextaLP,
    beforeEnter() {
      window.location = "https://texta.lightblue-tech.com/landing_page";
    }
  },
  {
    // 手洗い判定
    path: "/wash_hands",
    name: "WashHands",
    component: WashHands,
    beforeEnter() {
      window.location =
        "https://prtimes.jp/main/html/rd/p/000000018.000038247.html";
    }
  },
  {
    // マスクLP
    path: "/mask_LP",
    name: "MaskLP",
    component: MaskLP,
    beforeEnter() {
      window.location = "https://mask-ai-landing-page.lightblue-tech.com/";
    }
  },
  {
    // マスクブラウザ
    path: "/judge_mask",
    name: "JudgeMask",
    component: JudgeMask,
    beforeEnter() {
      window.location = "https://mask-app.lightblue-tech.com/";
    }
  },
  {
    // 1203セミナー資料
    path: "/seminar_1203",
    name: "Seminar1203",
    component: Seminar1203,
    beforeEnter() {
      window.location = "https://www.lightblue-tech.com/wp-content/uploads/2020/11/dx-casestudy.pdf";
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
